export default __webpack_public_path__ + "static/media/Dirk.66b0adc0.jpg";